import { Auth0Provider } from "@auth0/auth0-react";
import { Fragment } from "react";

export const Auth0provider = ({ children }: any) => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE
  const redirectUri = process.env.REACT_APP_AUTH0_REDIRECT_URL
  if(domain && clientId && audience && redirectUri)
  return (
    <Auth0Provider
      {...{ domain, clientId, audience, redirectUri }}
    >
      {children}
    </Auth0Provider>
  );

  return <Fragment>{children}</Fragment>
};
